/* lp-marquee — <lp-marquee>: moves a native horizontal scroller slowly (one list width per data-speed seconds) and
   wraps it by one list width, so four identical lists loop seamlessly. A finger or trackpad can drag it: it pauses
   while touched or hovered and carries on 1.5s after. Runs only while on screen. Reduced motion: nothing moves. */
(function () {
  'use strict';
  if (window.customElements.get('lp-marquee')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  class LpMarquee extends HTMLElement {
    connectedCallback() {
      if (reduce.matches) return;
      var self = this;
      this.list = this.querySelector('.lp-marquee__list');
      if (!this.list) return;
      /* not `dir`: that is the element's text-direction attribute and would swallow the number */
      this.sign = this.dataset.direction === 'right' ? -1 : 1;
      this.secs = Math.max(5, parseFloat(this.dataset.speed) || 45);
      this.inView = false; this.hover = false; this.touching = false; this.holdUntil = 0; this.last = 0;
      this.measure = function () {
        self.w = self.list.offsetWidth;
        if (!self.w) return;
        if (self.pos == null) { self.pos = self.w; self.scrollLeft = self.pos; }
      };
      this.tick = function (t) {
        self.raf = null;
        if (!self.inView) return;
        var dt = self.last ? Math.min(0.05, (t - self.last) / 1000) : 0; self.last = t;
        if (self.w && !self.hover && !self.touching && t > self.holdUntil) {
          self.pos += self.sign * (self.w / self.secs) * dt;
          self.wrap();
          self.ownScroll = true;
          self.scrollLeft = self.pos;
        }
        self.raf = requestAnimationFrame(self.tick);
      };
      this.start = function () { if (!self.raf && self.inView) { self.last = 0; self.raf = requestAnimationFrame(self.tick); } };
      /* a drag or swipe: take the position from the scroller, hold, then carry on */
      this.onScroll = function () {
        if (self.ownScroll) { self.ownScroll = false; return; }
        if (self.pos == null) return;
        if (Math.abs(self.scrollLeft - self.pos) > 2) {
          self.pos = self.scrollLeft;
          self.holdUntil = performance.now() + 1500;
          clearTimeout(self.wrapTimer);
          /* wrap once the swipe has settled (setting scrollLeft mid-fling would stop it) */
          self.wrapTimer = setTimeout(function () { var before = self.pos; self.wrap(); if (self.pos !== before) { self.ownScroll = true; self.scrollLeft = self.pos; } }, 160);
        }
      };
      this.onDown = function () { self.touching = true; };
      /* only a release that started on the ticker holds it (pointerup is on window so a drag that ends outside counts) */
      this.onUp = function () { if (!self.touching) return; self.touching = false; self.holdUntil = performance.now() + 1500; };
      this.onEnter = function (e) { if (e.pointerType === 'mouse') self.hover = true; };
      this.onLeave = function (e) { if (e.pointerType === 'mouse') { self.hover = false; } };
      this.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('pointerdown', this.onDown, { passive: true });
      this.addEventListener('touchstart', this.onDown, { passive: true });
      window.addEventListener('pointerup', this.onUp, { passive: true });
      window.addEventListener('touchend', this.onUp, { passive: true });
      this.addEventListener('pointerenter', this.onEnter);
      this.addEventListener('pointerleave', this.onLeave);
      this.onResize = function () { var old = self.w; self.measure(); if (old && self.w && old !== self.w) { self.pos = self.pos / old * self.w; self.wrap(); self.ownScroll = true; self.scrollLeft = self.pos; } };
      window.addEventListener('resize', this.onResize);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          self.inView = entries.some(function (e) { return e.isIntersecting; });
          if (self.inView) { self.measure(); self.start(); }
        });
        this.io.observe(this);
      } else { this.inView = true; this.measure(); this.start(); }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.onResize(); });
    }
    disconnectedCallback() {
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.io) this.io.disconnect();
      clearTimeout(this.wrapTimer);
      if (!this.onScroll) return;
      this.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('pointerdown', this.onDown);
      this.removeEventListener('touchstart', this.onDown);
      window.removeEventListener('pointerup', this.onUp);
      window.removeEventListener('touchend', this.onUp);
      this.removeEventListener('pointerenter', this.onEnter);
      this.removeEventListener('pointerleave', this.onLeave);
      window.removeEventListener('resize', this.onResize);
    }
    /* keep the position between one and two list widths: the lists are identical, so the jump is invisible */
    wrap() {
      var w = this.w; if (!w) return;
      while (this.pos >= 2 * w) this.pos -= w;
      while (this.pos < w) this.pos += w;
    }
  }
  window.customElements.define('lp-marquee', LpMarquee);
})();
